import { ChosenOptionAnswer, MappedAnswer } from '../../components/context/SurveyPageContext';

const getChosenOptionAnswer = (
  mappedAnswers: Map<number, MappedAnswer>,
  questionId: number,
): ChosenOptionAnswer | undefined => {
  if (mappedAnswers.has(questionId)) {
    return mappedAnswers.get(questionId) as ChosenOptionAnswer;
  }

  return undefined;
};

export default getChosenOptionAnswer;
